import React from "react"
import types from "prop-types"
import * as API from "services/api"
import { useDispatch, useSelector } from "react-redux"
import { setResolution } from "reduxSlices/formSubmissionResolutionSlice"
import { formSubmissionSlug as formSubmissionSlugSelector } from "reduxSlices/formSubmissionSlice"
import { useModal } from "hooks"
import Modal, { ModalHeader, DEFAULT_MODAL_STYLE } from "shared/Modal"
import { errorToast, successToast } from "shared/toast"
import AddResolutionButton from "./AddResolutionButton"
import ResolutionForm from "./ResolutionForm"

const MODAL_STYLE = {
  content: {
    ...DEFAULT_MODAL_STYLE.content,
    overflowX: "hidden",
  },
}

const AddResolution = ({ buttonClassName = "" }) => {
  const dispatch = useDispatch()

  const { modalIsOpen, openModal, closeModal } = useModal()

  const formSubmissionSlug = useSelector(formSubmissionSlugSelector)

  const cancelAddResolution = () => {
    closeModal()
  }

  const addResolution = async (resolutionData) => {
    const response = await API.createFormSubmissionResolution({ ...resolutionData, formSubmissionSlug })

    if (response.ok) {
      dispatch(setResolution({ resolution: response.data }))
      successToast("Resolution added successfully.")
      closeModal()
    } else {
      errorToast("Something went wrong. Unable to add resolution.")
    }
  }

  return (
    <>
      <AddResolutionButton className={buttonClassName} onClick={openModal} />
      <Modal isOpen={modalIsOpen} style={MODAL_STYLE}>
        <div className="flex flex-col">
          <ModalHeader closeModal={closeModal} heading="Resolution" />
        </div>
        <ResolutionForm onCancel={cancelAddResolution} onSubmit={addResolution} />
      </Modal>
    </>
  )
}

AddResolution.propTypes = {
  buttonClassName: types.string,
}

export default AddResolution
